/*
* 点位采集管理组件
* zxw
* 2025-05-20
*/

import { useState, useEffect } from 'react';
import $ from 'jquery';
import CNF from '../../incs/Config.js';
import {
    Row,
    Col,
    message,
    Table,
    Input,
    Select,
    Button,
    Upload,
    Modal,
    Tag,
    Space,
    Progress,
} from 'antd';
import {
    PlusOutlined,
    ExportOutlined,
    ImportOutlined,
    LoadingOutlined,
} from '@ant-design/icons';
import {
    UjoinParams,
    AddRequestHeaders,
    ShowIPModal,
    isGTscreenWidth,
    winWidth,
    UdateFormat,
    rootReactDom,
    GetArrSpanMaxWidth,
    GetButtonActionName,
} from '../../incs/FunHelper.js';
import ExportJsonExcel from 'js-export-excel';

import Entity from './InfoEntity.js';
import PLInfo from './PLInfo.js';

const Option = Select.Option;
const MODULENAME = CNF.navItems[0].submenu[1].name.replace('管理', '');
const MODULENAME_PTN = CNF.navItems[0].submenu[1].ptn;
const MODULENAME_URL = CNF.navItems[0].submenu[1].url;

const Lists = (props) => {
    const update = (record) => { props.setOpen(true, record); }

    /**
     * 操作选项
     * @param {*} action 
     * @param {*} record 
     */
    const operation = (action, record) => {
        let uri = MODULENAME_URL.slice(1,) + '/' + record.key;
        switch (action) {
            case CNF.actionName.UPDATE:
                update(record);
                break;
            case CNF.actionName.DISABLE:
            case CNF.actionName.ACTIVE:
            case CNF.actionName.DELETE:
                ShowIPModal(record.key, record.name, action, MODULENAME, props.setRefresh, uri);
                break;
            default:
                break;
        }
    }

    /**
     * 打印点位信息
     * @param {*} record 
     */
    const showPLInfo = (record) => {
        rootReactDom && rootReactDom.render(
            <PLInfo
                preGroup={props.preGroup}
                btnLists={props.btnLists}
                isModalOpen={true}
                record={record}
            />);
    }

    const columns = [
        { title: '', width: 20, dataIndex: '', key: 'key', fixed: 'left', },
        {
            title: '点位编号', key: 'number', fixed: 'left', width: 120,
            render: (record) => <Button
                color='primary'
                variant='link'
                style={{ padding: '0 5px', border: 0, height: 22 }}
                onClick={() => { showPLInfo(record); }}>{record.number}</Button>

        },
        { title: '派出所', dataIndex: 'police_station', key: 'police_station', fixed: 'left', width: 120, },
        { title: '点位名称', dataIndex: 'name', key: 'name', fixed: 'left', width: GetArrSpanMaxWidth(props.dataLists, 'name', 100), },
        { title: '点位详细地址', dataIndex: 'address', key: 'address', width: GetArrSpanMaxWidth(props.dataLists, 'address', 120), },
        { title: '所属点位采集', dataIndex: 'collect_number', key: 'collect_number', width: 120, },
        { title: '一杆几机', dataIndex: 'rod_device_count', key: 'rod_device_count', width: 100, },
        { title: '智能球', dataIndex: 'high_ball', key: 'hight_ball', width: 100, hidden: props.qss && props.qss.high_ball > 0 ? false : true, },
        { title: '双舱', dataIndex: 'double_cabins', key: 'double_cabins', width: 100, hidden: props.qss && props.qss.double_cabins > 0 ? false : true, },
        { title: '双拼', dataIndex: 'double_pinyin', key: 'double_pinyin', width: 100, hidden: props.qss && props.qss.double_pinyin > 0 ? false : true, },
        { title: '车辆卡口', dataIndex: 'vehicle_checkpoint', key: 'vehicle_checkpoint', width: 100, hidden: props.qss && props.qss.vehicle_checkpoint > 0 ? false : true, },
        { title: '智能箱', dataIndex: 'intelligent_box', key: 'intelligent_box', width: 100, },
        { title: '安装方式', dataIndex: 'installation_method', key: 'installation_method', width: 100, },
        {
            title: '杆型', key: 'rod_type', width: 100,
            render: (record) => record.rod_type ? record.rod_type : '-'
        },
        {
            title: '安装高度', key: 'installation_height', width: 100,
            render: (record) => record.installation_height ? record.installation_height : '-'
        },
        {
            title: '杆高', key: 'rod_height', width: 100,
            render: (record) => {
                if (record.installation_method === CNF.installationMethod[0].value && record.rod_height > 0) {
                    return record.rod_height + 'm'
                } else if (record.rod_height > 0) {
                    return '≥' + record.rod_height + 'm'
                } else {
                    return '-'
                }
            }

        },
        {
            title: '臂长', key: 'arm_length', width: 130,
            render: (record) => record.arm_length ? record.arm_length : '-'
        },
        {
            title: '臂朝向', key: 'arm_orientation', width: GetArrSpanMaxWidth(props.dataLists, 'arm_orientation', 100),
            render: (record) => record.arm_orientation ? record.arm_orientation : '-'
        },
        { title: '防控区域', dataIndex: 'control_area', key: 'control_area', width: GetArrSpanMaxWidth(props.dataLists, 'control_area', 100), },
        {
            title: '泥土路面', key: 'dirt_road', width: 100,
            render: (record) => record.dirt_road > 0 ? record.dirt_road + 'm' : '0.0'
        },
        {
            title: '水泥路面', key: 'cement_road', width: 100,
            render: (record) => record.cement_road > 0 ? record.cement_road + 'm' : '0.0'
        },
        {
            title: '沥青路面', key: 'asphalt_road', width: 100,
            render: (record) => record.asphalt_road > 0 ? record.asphalt_road + 'm' : '0.0'
        },
        {
            title: '人行道', key: 'sidewalk', width: 100,
            render: (record) => record.sidewalk > 0 ? record.sidewalk + 'm' : '0.0'
        },
        { title: '接电方式', dataIndex: 'connect_electricity_method', key: 'connect_electricity_method', width: 120, },
        {
            title: '电源长度', key: 'power_supply_length', width: 100,
            render: (record) => record.power_supply_length > 0 ? record.power_supply_length + 'm' : '0.0'
        },
        { title: '接电位置', dataIndex: 'connect_electricity_location', key: 'connect_electricity_location', width: GetArrSpanMaxWidth(props.dataLists, 'connect_electricity_location', 100), },
        { title: '经纬度', dataIndex: 'longitude_latitude', key: 'longitude_latitude', width: 250, },
        { title: '采集日期', dataIndex: 'collection_date', key: 'collection_date', width: 100, },
        { title: '创建时间', dataIndex: 'create_time', key: 'create_time', width: CNF.tableCreateTimeColumnWidth, },
        { title: '创建者', dataIndex: 'create_displayname', key: 'create_displayname', width: CNF.tableCreateDisplayeColumnWidth, },
        { title: '状态', key: 'status', dataIndex: 'status', width: CNF.tableStatusColumnWidth - 20, },
        {
            title: '', key: 'operation', fixed: 'right', width: 168, hidden: (
                props.btnLists.indexOf(MODULENAME_PTN + '_visit') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_update') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_disable') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_active') > 0 ||
                props.btnLists.indexOf(MODULENAME_PTN + '_delete') >= 0
            ) ? false : true,
            render: (record) => GetButtonActionName(props.btnLists, MODULENAME_PTN, record, operation)
        }
    ];
    return (
        <>
            <Table
                columns={columns}
                size='middle'
                dataSource={props.dataLists}
                scroll={{ x: winWidth }}
                pagination={{
                    showSizeChanger: false,
                    // pageSizeOptions: ['10', '15', '20', '30','40','50'],
                    showQuickJumper: false,
                    showTotal: () => <>
                        总计：<Tag color={CNF.swatches[CNF.currentSwatche][0]}>{props.qss.rod_device_count}个</Tag>
                        {
                            props.qss.high_ball > 0 ? <>
                                智能球：<Tag color={CNF.swatches[CNF.currentSwatche][1]}>{props.qss.high_ball}个</Tag>
                            </> : ''
                        }
                        {
                            props.qss.double_cabins > 0 ? <>
                                双舱：<Tag color={CNF.swatches[CNF.currentSwatche][2]}>{props.qss.double_cabins}个</Tag>
                            </> : ''
                        }
                        {
                            props.qss.double_pinyin > 0 ? <>
                                双拼：<Tag color={CNF.swatches[CNF.currentSwatche][3]}>{props.qss.double_pinyin}个</Tag>
                            </> : ''
                        }
                        {
                            props.qss.vehicle_checkpoint > 0 ? <>
                                车辆卡口：<Tag color={CNF.swatches[CNF.currentSwatche][4]}>{props.qss.vehicle_checkpoint}个</Tag>
                            </> : ''
                        }
                        共{props.pageCount > 10000 ? (props.pageCount / 10000).toFixed(CNF.DPL) + '万' : props.pageCount}条,
                    </>,
                    pageSize: CNF.pageSize,
                    current: props.currentIndex,
                    total: props.pageCount,
                    onShowSizeChange: (current, pageSize) => props.changePageSize(pageSize, current),
                    onChange: (current) => props.changeIndex(current),
                }}
            />
        </>
    );
}

const Info = (props) => {
    const [messageApi, contextHolder] = message.useMessage();
    const [modal, modalContextHolder] = Modal.useModal();
    const [instance, setInstance] = useState(null);

    const [isRefresh, setIsRefresh] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [dataLists, setDataLists] = useState([]);
    const [qss, setQss] = useState(null);
    const [record, setRecord] = useState(null);
    const [open, setOpen] = useState(false);

    const [collectLists, setCollectLists] = useState([]);
    const [collectUlid, setCollectUlid] = useState('');
    const [number, setNumber] = useState('');
    const [name, setName] = useState('');
    const [status, setStatus] = useState(CNF.status[0].value);

    const setRefresh = () => {
        setIsRefresh(!isRefresh);
    }

    const openEntity = (value, record = null) => {
        setOpen(value);
        setRecord(record);
    }

    const create = () => { openEntity(true, null); }

    useEffect(() => {
        /***
         * 获取项目下拉列表
         */
        const collectDDList = () => {
            const params = {
                'rss': 'list',
                'page_size': CNF.maxPageSize,
                'current_index': 1
            };
            $.ajax({
                url: `${CNF.api}pointLocation/collects${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                crossDomain: true,
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        setCollectLists(data.dat);
                    }
                }
            })
        }
        collectDDList();
    }, []);


    useEffect(() => {
        /**
         * 获取列表
         */
        const getLists = () => {
            const params = {
                'collect_ulid': collectUlid,
                'number': number,
                'name': name,
                'status': status,
                'page_size': CNF.pageSize,
                'current_index': currentIndex
            };
            $.ajax({
                url: `${CNF.api}${MODULENAME_URL.slice(1,)}${UjoinParams(params)}`,
                headers: AddRequestHeaders(),
                type: 'GET', success: function (data) {
                    if (data.res === 0) {
                        if (data.dat.length > 0) {
                            setDataLists(data.dat);
                            setPageCount(data.cnt);
                            setQss(data.qss);
                        } else {
                            setDataLists([]);
                            setPageCount(0);
                            setQss(null);
                        }
                    } else {
                        messageApi.error(data.msg, CNF.messageDuration);
                    }
                }
            })
        }
        getLists();
    }, [currentIndex, messageApi, isRefresh, number, collectUlid, name, status]);


    /**
     * 导入前检查
     * @param {*} info 
     * @returns 
     */
    const uploadCheck = (info) => {
        if (info.size > 10240000) {
            message.error('上传文件超过10M，建议拆分文件！', CNF.messageDuration);
            return false
        }
        if (info.name.match(/.xls[x]{0,1}/) === null) {
            message.error('文件格式不对，只支持 xls 或 xlsx ！', CNF.messageDuration);
            return false
        }
        setInstance(modal.info({
            width: isGTscreenWidth ? 500 : 600,
            title: <Space>文件正在上传<LoadingOutlined /></Space>,
            content: <Progress percent={0} />,
            footer: null,
            icon: null,
            keyboard: false,
            closable: false,
        }));
        return true
    }

    /**
     * 更新导入弹框
     * @param {*} modal 
     * @param {*} title 
     * @param {*} data 
     * @param {*} percent 
     */
    const updateModal = (modal, title, data, percent) => {
        modal.update((prevConfig) => ({
            ...prevConfig,
            title: title,
            content: <>
                <Progress percent={percent} style={{ width: '100%' }} />
                <Row style={{ marginTop: CNF.rowMarginTop, }}>
                    <Col span={4}><strong>序号</strong></Col>
                    <Col span={12}><strong>工单编号</strong></Col>
                    <Col span={8}><strong>操作说明</strong></Col>
                </Row>
                <div id='import-modal-id' style={{
                    height: 360,
                    marginTop: CNF.rowMarginTop,
                    overflowY: 'auto',
                }}>
                    {
                        data.length > 0 &&
                        data.map((item, index) => {
                            return (
                                <Row style={{ lineHeight: 2 }} key={index}>
                                    <Col span={4}>{item['key']}</Col>
                                    <Col span={12}>{item['number']}</Col>
                                    <Col span={8} style={{ color: item['msg'].indexOf('成功') >= 0 ? '#000' : item['msg'].indexOf('已导入') >= 0 ? 'green' : 'red' }}>{item['msg']}</Col>
                                </Row>
                            )
                        })
                    }
                </div>
                {
                    title === '工单导入完成！' || title === '工单导入结束！' ? <div style={{ marginTop: CNF.rowMarginTop * 2, width: '100%', textAlign: 'right' }}>
                        <Button
                            title='确定'
                            variant='solid'
                            style={{ background: global.THEMECOLOR, color: '#fff', border: 0, }}
                            onClick={() => {
                                modal.destroy(); // 退出导入进度界面
                                setRefresh();
                            }}
                        >
                            确定
                        </Button></div> : ''
                }
            </>
        }));
    }

    /**
     * 获取任务
     * @param {*} modal 
     * @param {*} jobId 
     */
    const getJob = async (modal, jobId) => {
        instance.update((prevConfig) => ({
            ...prevConfig,
            title: <Space>工单正在导入<LoadingOutlined /></Space>,
            content: <Progress percent={0} />,
        }));
        let messageData = [];
        try {
            const response = await fetch(CNF.api + 'wos/lists?job_id=' + jobId,
                {
                    method: 'GET',
                    headers: AddRequestHeaders(),
                    openWhenHidden: true,
                });
            if (response.ok && response.status === 200) {
                //  连接成功
            } else {
                //  连接失败
            }
            const reader = response.body.getReader();
            const td = new TextDecoder('utf-8');
            let jsonData = null;
            while (true) {
                const { done, value } = await reader.read();
                const text = td.decode(value, { stream: true });
                if (done) {
                    // 完成, 更新进度
                    updateModal(modal, jsonData.id === jsonData.total ? '工单导入完成！' : '工单导入结束！', messageData, (parseFloat(jsonData.id / jsonData.total) * 100).toFixed(CNF.DPL));
                    break;
                }
                let jsonMatch = text.match(/data:\s*({.*?})\s*\n/);
                if (jsonMatch) {
                    jsonData = JSON.parse(jsonMatch[1]);
                } else {
                    continue;
                }
                // jsonData = JSON.parse(text.match(/data:\s*({.*?})\s*\n/)[1]);
                if (jsonData.res !== 0) {
                    // 接口返回操作不成功，退出循环
                    modal.destroy(); // 退出导入进度界面
                    messageApi.error(jsonData.msg, CNF.messageDuration);
                    break;
                }
                // 更新进度
                messageData.push(...(jsonData.data));
                updateModal(modal, <Space>工单正在导入<LoadingOutlined /></Space>, messageData, (parseFloat(jsonData.id / jsonData.total) * 100).toFixed(CNF.DPL));
                let div = document.getElementById('import-modal-id');
                if (div) {
                    div.scrollTop = div.scrollHeight;
                    div.style.scrollBehavior = 'smooth'; // 启用平滑滚动效果
                    div.scrollTo(0, div.scrollHeight); // 滚动到最底部
                }
            }
        } catch (e) {
            // 异常
            instance.update((prevConfig) => ({
                ...prevConfig,
                closable: true, // 开启关闭按钮
                onCancel: () => {
                    setRefresh();
                }
            }));
            messageApi.error('网络错误 !', CNF.messageDuration);
        }
    }

    /**
     * 执行导入
     * @param {*} info 
     */
    const upload = (info) => {
        if (info.file.status === 'uploading') {
            instance.update((prevConfig) => ({
                ...prevConfig,
                content: <Progress percent={parseFloat(info.file.percent).toFixed(CNF.DPL)} />,
            }));
        } else if (info.file.status === 'done') {
            instance.update((prevConfig) => ({
                ...prevConfig,
                title: '文件上传完成！',
                content: <Progress percent={100} />,
            }));
            if (info.file.response.dat) {
                setTimeout(() => {
                    getJob(instance, info.file.response.dat?.job_id);
                }, 1000);

            } else {
                instance.destroy();
                messageApi.error(info.file.response.msg, CNF.messageDuration);
            }
        } else if (info.file.status === 'error') {
            modal.destroy(); // 退出导入进度界面
            messageApi.error(`${info.file.name} 导入失败！`, CNF.messageDuration);
        }
    }

    /***
    * 导出 Excel
    */
    const exportAsExcel = (data) => {
        var date = new Date();
        let option = {};  //    option代表的就是excel文件
        option.fileName = '点位信息明细-' + UdateFormat('YYYY-mm-dd', date);  //   excel文件名称
        option.datas = [
            {
                sheetData: data,  //   excel文件中的数据源
                sheetName: '点位信息明细',  //  excel文件中sheet页名称
                sheetHeader: [
                    '点位编号',
                    '派出所',
                    '点位名称',
                    '点位详细地址',
                    '所属点位采集',
                    '一杆几机',
                    '智能球',
                    '双舱',
                    '双拼',
                    '车辆卡口',
                    '智能箱',
                    '安装方式',
                    '杆型',
                    '安装高度',
                    '杆高',
                    '臂长',
                    '臂朝向',
                    '防控区域',
                    '泥土路面',
                    '水泥路面',
                    '沥青路面',
                    '人行道',
                    '接电方式',
                    '电源长度',
                    '接电位置',
                    '经纬度',
                    '采集日期',
                    '备注'],  //  excel文件中每列的表头名称
            }
        ]
        let toExcel = new ExportJsonExcel(option);  //生成excel文件
        toExcel.saveExcel();  //下载excel文件
    }


    /***
     * 获取导出车辆信息明细
     */
    const exportAsLists = () => {
        const params = {
            'collect_ulid': collectUlid,
            'number': number,
            'name': name,
            'status': status,
            'page_size': CNF.maxPageSize,
            'current_index': 1
        }
        $.ajax({
            url: `${CNF.api}pointLocation/infos${UjoinParams(params)}`,
            headers: AddRequestHeaders(),
            type: 'GET', success: function (data) {
                if (data.res === 0) {
                    if (data.dat.length > 0) {
                        //  删除非必须字段
                        var d = [];
                        for (let i = 0; i < data.dat.length; i++) {
                            var item = data.dat[i]
                            delete item['key'];
                            delete item['create_username'];
                            delete item['create_displayname'];
                            delete item['create_time'];
                            delete item['update_time'];
                            delete item['status'];
                            delete item['collect_ulid'];
                            delete item['collect_name'];
                            delete item['installation_location_image_path'];
                            delete item['connect_electricity_location_image_path'];
                            // int或float类型大于0的转换成字符串并加上“m”单位
                            item['rod_height'] = item['rod_height'] > 0 ? item['rod_height'].toString() + 'm' : item['rod_height']; //  杆高
                            item['dirt_road'] = item['dirt_road'] > 0 ? item['dirt_road'].toString() + 'm' : item['dirt_road']; // 泥土路面
                            item['cement_road'] = item['cement_road'] > 0 ? item['cement_road'].toString() + 'm' : item['cement_road']; // 水泥路面
                            item['asphalt_road'] = item['asphalt_road'] > 0 ? item['asphalt_road'].toString() + 'm' : item['asphalt_road']; // 沥青路面
                            item['sidewalk'] = item['sidewalk'] > 0 ? item['sidewalk'].toString() + 'm' : item['sidewalk']; // 人行道
                            item['power_supply_length'] = item['power_supply_length'] > 0 ? item['power_supply_length'].toString() + 'm' : item['power_supply_length']; // 电源长度
                            d.push(item);
                        }
                        exportAsExcel(d);
                    } else {
                        exportAsExcel([]);
                    }
                } else {
                    messageApi.error(data.msg, CNF.messageDuration);
                }
            }
        })
    }

    return (
        <>
            {contextHolder}
            {modalContextHolder}
            <Row style={{ paddingTop: CNF.searchMarginLeft * 4, paddingBottom: CNF.searchMarginLeft * 4, paddingLeft: CNF.searchMarginLeft * 4 }}>
                <Col span={isGTscreenWidth ? 4 : 5} style={{ marginLeft: CNF.searchMarginLeft }}>
                    <Select
                        showSearch
                        allowClear
                        placeholder='所属点位采集'
                        style={{ width: '100%' }}
                        onChange={(value) => setCollectUlid(value ? value : '')}
                        filterOption={(input, option) => option.props.children.indexOf(input) >= 0}
                    >
                        {
                            collectLists && collectLists.map((item) => {
                                return <Option key={item.key} value={item.key}>{item.name}</Option>
                            })
                        }
                    </Select>
                </Col>
                <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                    <Input
                        onChange={(e) => setNumber(e.target.value)}
                        placeholder='点位编码'
                        value={number}
                    />
                </Col>
                <Col span={isGTscreenWidth ? 2 : 3} style={{ marginLeft: CNF.searchMarginLeft }}>
                    <Input
                        onChange={(e) => setName(e.target.value)}
                        placeholder='点位名称'
                        value={name}
                    />
                </Col>
                <Col span={2} style={{ marginLeft: CNF.searchMarginLeft }}>
                    <Select
                        allowClear
                        placeholder='状态'
                        style={{ width: '100%' }}
                        onChange={(value) => setStatus(value ? value : '')}
                        options={CNF.status.map((item, index) => ({
                            key: index,
                            value: item.value,
                            label: item.key
                        }))}
                    />
                </Col>
                <Space size={CNF.searchMarginLeft} style={{ marginLeft: CNF.searchMarginLeft }}>
                    {
                        props.btnLists.indexOf(MODULENAME_PTN + '_create') >= 0 ? (
                            <Button
                                title={CNF.actionName.CREATE + MODULENAME}
                                color='primary'
                                variant='solid'
                                icon={<PlusOutlined />}
                                onClick={() => {
                                    create();
                                }}>
                                {CNF.actionName.CREATE}
                            </Button>
                        ) : ''
                    }
                    {
                        props.btnLists.indexOf(MODULENAME_PTN + '_import') >= 0 ? (
                            <Upload
                                action={CNF.api + 'pointLocation/infoLists'}
                                headers={AddRequestHeaders(false)}
                                onChange={upload}
                                beforeUpload={uploadCheck}
                                showUploadList={false}
                                name='file'
                                accept='xlsx,xls'
                            >
                                <Button
                                    title={CNF.actionName.IMPORT + MODULENAME}
                                    color='primary'
                                    variant='solid'
                                    icon={<ImportOutlined />}>
                                    {CNF.actionName.IMPORT}
                                </Button>
                            </Upload>

                        ) : ''
                    }
                    {
                        props.btnLists.indexOf(MODULENAME_PTN + '_export') >= 0 ? (
                            <Button
                                title={CNF.actionName.EXPORT + MODULENAME}
                                color='primary'
                                variant='solid'
                                icon={<ExportOutlined />}
                                onClick={() => {
                                    exportAsLists();
                                }}>
                                {CNF.actionName.EXPORT}
                            </Button>
                        ) : ''
                    }
                </Space>
                <Entity
                    policy={props.policy}
                    preGroup={props.preGroup}
                    btnLists={props.btnLists}
                    open={open}
                    record={record}
                    collectLists={collectLists}
                    setOpen={setOpen}
                    setRefresh={setRefresh}
                />
            </Row >
            <Row>
                <Col span={24}>
                    <Lists
                        btnLists={props.btnLists}
                        dataLists={dataLists}
                        currentIndex={currentIndex}
                        pageCount={pageCount}
                        qss={qss}
                        changeIndex={setCurrentIndex}
                        setOpen={openEntity}
                        setRefresh={setRefresh}
                    />
                </Col>
            </Row>
        </>
    );
}

export default Info